// extracted by mini-css-extract-plugin
module.exports = {"caption":"will_caption__2CudZ","text-block":"will_text-block__1Ic-V"};